module.exports = __webpack_public_path__ + "static/media/payout_icon_success.65db820d.png";